/** @jsx jsx */
import React, { useState, useEffect } from 'react';
import { Link, withPrefix } from "gatsby";
import { jsx, useColorMode } from "theme-ui";
import replaceSlashes from "@lekoarts/gatsby-theme-minimal-blog/src/utils/replaceSlashes";
import useSiteMetadata from "@lekoarts/gatsby-theme-minimal-blog/src/hooks/use-site-metadata";
import useMinimalBlogConfig from "@lekoarts/gatsby-theme-minimal-blog/src/hooks/use-minimal-blog-config";

const HeaderTitle = () => {
  const { siteTitle } = useSiteMetadata();
  const { basePath } = useMinimalBlogConfig();
  const [colorMode] = useColorMode<"light" | "dark">();
  const [logoUrl, setLogoUrl] = useState<string>("/logos/KSM-Logo-dark.svg");
  
  useEffect(() => {
    const isLight = colorMode === 'light';
    const newLogo = isLight ? "/logos/KSM-Logo.svg" : "/logos/KSM-Logo-dark.svg";
    setLogoUrl(withPrefix(newLogo));
  }, [colorMode]);

  return (
    <Link to={replaceSlashes(`/${basePath}`)} aria-label={`${siteTitle} - Back to home`} sx={{ color: `heading`, textDecoration: `none` }}>
      <img alt="KSM Home" src={logoUrl} height="150"></img>
    </Link>
  );
};

export default HeaderTitle;
